import { redirect } from "lib/util";

import component from "../components";
import events from "../events";

export default function initSignup(accountType = null) {
    const signupView = new component.SignupView({
        el: ".signup-form form",
        template: false,
        accountType,
    });
    signupView.render();
    signupView.on("auth:success", () => {
        if (signupView.model.isHiringManager()) {
            events.sendConversion("d_LrCKCptZMCEMGjhrIB", "AW-373395905"); // AdWords: Employer Sign-up
            redirect("/portal/", 350);
        } else {
            events.sendConversion("YhCwCO3bi4wBEPDw1Z8D"); // AdWords: Candidate Sign-up
            events.sendConversion("XXdfCMHNgpQBEILAyu0C", "AW-766681090");

            if (window.fbq) {
                window.fbq("track", "Lead");
            }

            if (window.lintrk) {
                window.lintrk("track", { conversion_id: 4527028 });
            }

            redirect(window.redirect || "/", 350);
        }
    });
}
